import { TENANTS } from "../../../constants"
import { loc } from "../../../core/utils"
import React from "react"

const TopbarBasketPrice = ({ rent, tenant, formatPrice }) => {
  const { monthlyTotal } = rent

  if (tenant === TENANTS.BPLS) return null

  return (
    <p className="header-price">
      {formatPrice(monthlyTotal)}
      {} <small>{loc("/month")}</small>
    </p>
  )
}

export default TopbarBasketPrice
